import { CadorReference } from './cador-reference';

export class RequestOrigin {

    libelleConfigurable: CadorReference;

    isSelfRequest: boolean;

    isResidentVaud: boolean;

    initiator: CadorReference;

    lastName: string;

    firstName: string;

    email: string;

    phone: string;

    situation: CadorReference = new CadorReference();

}
